import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';
import PublicLayout from '@/components/PublicLayout';

export default function Privacy() {
  return (
    <PublicLayout>
      <main className="pt-20 pb-14 lg:pt-28 lg:pb-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl border border-slate-200/80 shadow-sm p-8 lg:p-10">
            <div className="flex items-center justify-between mb-10">
              <div>
                <h1 className="text-2xl sm:text-3xl font-semibold text-slate-900 tracking-tight">
                  Privacy Policy
                </h1>
                <p className="text-slate-600 mt-2">
                  Last updated: {new Date().toLocaleDateString()}
                </p>
              </div>
              <div className="hidden sm:flex w-12 h-12 rounded-xl bg-slate-100 items-center justify-center">
                <Shield className="w-6 h-6 text-slate-700" />
              </div>
            </div>

            <div className="prose prose-slate max-w-none">
              <section className="mb-8">
                <h2 className="text-lg font-semibold text-slate-900 mb-4">1. Introduction</h2>
                <p className="text-slate-600 leading-relaxed">
                  Hoito (&quot;we&quot;, &quot;our&quot;, or &quot;us&quot;) is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our financial management platform.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-lg font-semibold text-slate-900 mb-4">2. Information We Collect</h2>
                <h3 className="text-base font-medium text-slate-900 mb-2">2.1 Personal Information</h3>
                <ul className="list-disc pl-6 mb-4 text-slate-600 space-y-1">
                  <li>Name and contact information</li>
                  <li>Financial account information</li>
                  <li>Transaction data</li>
                  <li>Authentication credentials</li>
                </ul>

                <h3 className="text-base font-medium text-slate-900 mb-2">2.2 Usage Information</h3>
                <ul className="list-disc pl-6 mb-4 text-slate-600 space-y-1">
                  <li>Device and browser information</li>
                  <li>IP address and location data</li>
                  <li>Usage patterns and preferences</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-lg font-semibold text-slate-900 mb-4">3. How We Use Your Information</h2>
                <ul className="list-disc pl-6 mb-4 text-slate-600 space-y-1">
                  <li>To provide and maintain our services</li>
                  <li>To process your transactions</li>
                  <li>To communicate with you</li>
                  <li>To improve our services</li>
                  <li>To comply with legal obligations</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-lg font-semibold text-slate-900 mb-4">4. Data Security</h2>
                <p className="text-slate-600 leading-relaxed">
                  We implement appropriate technical and organizational security measures to protect your personal information. However, no electronic transmission over the Internet or information storage technology can be guaranteed to be 100% secure.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-lg font-semibold text-slate-900 mb-4">5. GDPR Compliance</h2>
                <p className="text-slate-600 mb-4 leading-relaxed">
                  For users in the European Union, we comply with GDPR requirements and provide the following rights:
                </p>
                <ul className="list-disc pl-6 mb-4 text-slate-600 space-y-1">
                  <li>Right to access your personal data</li>
                  <li>Right to rectification</li>
                  <li>Right to erasure</li>
                  <li>Right to restrict processing</li>
                  <li>Right to data portability</li>
                  <li>Right to object</li>
                </ul>
              </section>

              <section>
                <h2 className="text-lg font-semibold text-slate-900 mb-4">6. Contact Us</h2>
                <p className="text-slate-600 leading-relaxed">
                  If you have any questions about this Privacy Policy, please contact us at:
                  <br />
                  <a href="mailto:hello@hoitodigital.com" className="text-brand-900 hover:text-brand-800 font-medium">
                    hello@hoitodigital.com
                  </a>
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
    </PublicLayout>
  );
}
